import React, {Fragment} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {CONTENT_TYPES} from "./assignQuoteConstants";
import {setAssignQuotePopupCustomer, setAssignQuotePopupUserInfo} from "./assignPopupFunctions";
// import {loadingDialog_show} from "../../../../actions";
import {getCustomerById, postCloneJob, userRegister} from "./assignQuoteActions";
import {store} from "../../../../main";
import {fetchJobs} from "../../../JobBoard/JobBoardActions";

const getUpdatedUserInfoFromTheResponse = (newUserInfo, responseCustomer) => {
  if (responseCustomer.phone) {
    newUserInfo.phone = responseCustomer.phone;
    newUserInfo.phoneNumber = responseCustomer.phone;
  }
  if (responseCustomer.address) {
    ["address1", "address2", "postal", "city", "provence", "country"].forEach(key => {
      if (responseCustomer.address[key]) {
        newUserInfo[key] = responseCustomer.address[key]
      }
    })
  }
  newUserInfo.shipping = responseCustomer.shipping;
  return newUserInfo
}

const AssignQuotePopupSaveButtons = (props) => {

  const {closePopup, assignQuotePopupEmployee, userInfo, setAssignQuotePopupUserInfo, changeContext,
    contentType, updateInputValidations, userRegister, getCustomerById, postCloneJob, copyJob} = props;
  let {assignQuotePopupCustomer} = props;

  const handleAssignQuote = async () => {

    if (contentType === CONTENT_TYPES.newCustomer) {

      await updateInputValidations();
      const errors = store.getState().assignQuoteState.userInfoErrors;
      if (Object.keys(errors).length && Object.keys(errors).some(key => errors[key] && errors[key].length)) {
        return false
      }

      const registered = await userRegister({assignQuote: true});
      console.log("successfully registered", registered);
      if (registered && !registered.error) {
        assignQuotePopupCustomer = { // clear current selected customer
          id: registered.id,
          email: userInfo.email,
          fullName: userInfo.firstName + (userInfo.lastName ? " " + userInfo.lastName : ""),
        }
        setAssignQuotePopupCustomer(assignQuotePopupCustomer);
      } else {
        return false
      }
    } else if (!assignQuotePopupCustomer) { // contentType === CONTENT_TYPES.searchCustomer
      changeContext({customerError: "assignPopup.customersTitleError"});
      return false
    }

    let newUserInfo = {};
    if (assignQuotePopupCustomer && assignQuotePopupCustomer.id) {
      newUserInfo.firstName = assignQuotePopupCustomer.fullName;
      newUserInfo.email = assignQuotePopupCustomer.email;
      const responseCustomer = await getCustomerById(assignQuotePopupCustomer.id); // receive other data from BE
      console.log("responseUser", responseCustomer);
      if (responseCustomer) {
        newUserInfo = getUpdatedUserInfoFromTheResponse(newUserInfo, responseCustomer);
      }
      console.log("newUserInfo", newUserInfo);
    }
    if (assignQuotePopupEmployee) {
      newUserInfo.employeeId = assignQuotePopupEmployee.id;
    }
    await setAssignQuotePopupUserInfo(newUserInfo);

    postCloneJob({
      jobId: copyJob.id,
      assignQuotePopupCustomer: assignQuotePopupCustomer,
      assignQuotePopupEmployee: assignQuotePopupEmployee || null
    })
      .then((response) => {
        if (response && !response.error && !response.message) {
          closePopup();
          fetchJobs(); // update jobs list
        }
      })
  };

  return (
    <Fragment>
      <button className="ui-button5 ui-button5--green text-uppercase ui-button5--bold" onClick={() => handleAssignQuote(false)}>
        <FormattedMessage id="assignPopup.createQuoteButton"/>
      </button>
    </Fragment>
  )
};

AssignQuotePopupSaveButtons.propTypes = {
  updateInputValidations: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired,
  changeContext: PropTypes.func.isRequired,
  contentType: PropTypes.oneOf([
    CONTENT_TYPES.searchCustomer,
    CONTENT_TYPES.newCustomer
  ]),
}

const mapStateToProps = (store) => {
  const {userInfo, assignQuotePopupCustomer, assignQuotePopupEmployee, copyJob} = store.assignQuoteState;
  return {
    assignQuotePopupCustomer,
    assignQuotePopupEmployee,
    copyJob,
    fabricatorData: {
      settings: {}
    },
    userInfo,
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupUserInfo,
  setAssignQuotePopupCustomer,
  userRegister,
  getCustomerById,
  postCloneJob,
  fetchJobs
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupSaveButtons)
)
